
import  Card  from "../../layout/Card";
import Master from "../../layout/Master";
import Sidbar from "../../layout/Sidbar";
import ItemsAboutUs from "./ItemsAboutUs";
import { VscFeedback, VscCheckAll } from "react-icons/vsc";
import './About.css'
import BCButom from "../../Tools/BCButom";
const About = () => {
    return (
        <Master>
            <Sidbar>
                <Card style={{background: "", boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px", height: "400px"}}>
                    <div className="AboutUsImage">
                        <img src={`/image/Doctor/1$1658213511.jpg`} className={`imageDoctor`}/>
                    </div>  
                    <div className="AboutUsText">
                        <h3>درباره دکتر هادی مدقق</h3>
                        <p>
                        آقای دکتر مدقق فوق تخصص جراحی عروق و فلوشیپ اینترونشن از لایپزیگ المان دارای رتبه استادی (پروفسور) دانشگاه در سال ١٣٧٩ از دانشگاه تهران با ماموریت راه اندازی بخش جراحی عروق در دانشگاه علوم پزشکی مشهد به این شهر عزیمت نمودند و در زمستان همان سال بخش فوق تخصصی جراحی عروق را در بیمارستان امام رضا ع راه‌اندازی نمودند و در سالهای بعد دوره آموزش فوق‌تخصصی این رشته، مرکز تحقیقات جراحی عروق و اندوواسکولار و در نهایت واحد اندوواسکولار (آنژیوپلاستی) را راه‌اندازی نمودند. با راه اندازی هیئت بورد فوق تخصصی این رشته در کشور ایشان به عنوان دبیر هیئت بورد برگزیده شدند. قبل از حضور ایشان در مشهد درمان بخشی از بیماران عروقی توسط بعضی از اساتید رشته جراحی عمومی و جراحان توراکس (قفسه سینه) انجام می شده است. در سال ۱۳۹۵ به منظور ارتقاء و توسعه رشته و به تصمیم دانشگاه علوم پزشکی مشهد کلیه امکانات رشته جراحی عروق از بیمارستان امام رضا (ع) به بیمارستان علوی منتقل گردید و آقای دکتر مدقق به ریاست بیمارستان منصوب گردیدند.
                        </p>
                        <a href="https://app.minns.cloud/reservations/reserve/1?_token=5NjJVk7oSsGRKvffJTxGWhS8EjSKhQ5erfQoDaop&selected_location=1&account_id=1&payment_type=&reservation_time_id=" target={`_blank`}><BCButom className='btnTow pt-1 pb-1'> رزرو نوبت </BCButom></a>
                        <a href="https://app.minns.cloud/reservations/home/1" target={`_blank`}><BCButom className='btnTow pt-1 pb-1'> ارتباط با دکتر هادی مدقق</BCButom></a>
                        {/* <button type="button" className="BtnAboutUs"></button>
                        <button type="button" className="BtnAboutUs"></button> */}
                    </div>
                </Card>    
                <Card style={{background: "rgb(255, 255, 255)", height: "auto"}}>
                    <ItemsAboutUs icon={<VscCheckAll />}>
                    ریاست بیمارستان فوق تخصصی جراحی عروق علوی
                    </ItemsAboutUs><ItemsAboutUs icon={<VscCheckAll />}>
                    استاد جراحی عروق دانشگاه علوم پزشکی مشهد
                    </ItemsAboutUs>
                    <ItemsAboutUs icon={<VscCheckAll />}>
                    ریاست مرکز تحقیقات جراحی عروق و اندوواسکولار دانشگاه علوم پزشکی مشهد
                    </ItemsAboutUs>
                    <ItemsAboutUs icon={<VscCheckAll />}>
                    معاون درمان دانشگاه علوم پزشکی مشهد
                    </ItemsAboutUs>
                    <ItemsAboutUs icon={<VscCheckAll />}>
                    ریاست بخش فوق تخصصی جراحی عروق بیمارستان امام رضا (ع)
                    </ItemsAboutUs>
                    <ItemsAboutUs icon={<VscCheckAll />}>
                    مدیر گروه جراحی دانشگاه علوم پزشکی مشهد
                    </ItemsAboutUs>
                    <ItemsAboutUs icon={<VscCheckAll />}>
                    دبیر هیات ممتحنه دانشنامه فوق تخصصی رشته جراحی عروق
                    </ItemsAboutUs>
                    <ItemsAboutUs icon={<VscCheckAll />}>
                    عضو هیات ممتحنه دانشنامه تخصصی رشته جراحی عمومی
                    </ItemsAboutUs>
                    <ItemsAboutUs icon={<VscCheckAll />}>
                    عضو هیئت علمی رشته جراحی در دانشگاه علوم پزشکی تهران
                    </ItemsAboutUs>
                    <ItemsAboutUs icon={<VscCheckAll />}>
                    برگزیده جشنواره تحقیقاتی علوم پزشکی رازی
                    </ItemsAboutUs>
                    <ItemsAboutUs icon={<VscCheckAll />}>
                    سرپرست مرکز تحقیقات تروما و جراحی سینا دانشگاه علوم پزشکی تهران
                    </ItemsAboutUs>
                    <ItemsAboutUs icon={<VscCheckAll />}>
                    معاون آموزشی گروه جراحی دانشگاه علوم پزشکی تهران
                    </ItemsAboutUs>


                </Card><Card style={{background: "rgb(255, 255, 255)", height: "400px"}}>

                </Card>
            </Sidbar>
        </Master>
    )
}
export default About;